// extracted by mini-css-extract-plugin
export default {"headerContainer":"_9fe3b3e9","header":"_483d24ae","viewMore":"_846d64e9","itemsContainer":"_9b6bac50"};